// Состояние сети для глобального индикатора в App.vue.
//
// problem — «сеть лежит»: взводит response-interceptor на транзиентных ошибках,
// снимает первый успешный ответ. НЕ персистится (см. store/crmPersist.js).
//
// loadClaims — кто из страниц взялся объяснить сетевой отказ сам, своим блоком
// «Повторить». Заявку делает ПУТЬ ЗАГРУЗКИ страницы, а не присутствие компонента
// на экране: это разные факты. Холистическое ревью 19.09.2026 показало пробами,
// что на присутствии механизм врёт в обе стороны — заявка исчезала на время
// ретрая (и поверх лоадера всплывала глобальная модалка), а скрытый v-show или
// не размонтированный Vuetify'ем v-tab-item держали её вечно.
//
// Ключ — на экземпляр страницы, поэтому повторная заявка идемпотентна, а чужая
// не снимается: две карточки в дровере и в роуте не гасят индикатор друг другу.
//
// state — фабрика, а не объект: объектный литерал Vuex берёт по ссылке, и
// коммиты в одном store протекают в соседние (ловилось полным прогоном спеков).
export default {
  namespaced: true,
  state: () => ({
    problem: false,
    loadClaims: [],
  }),
  mutations: {
    SET_PROBLEM(state, value) {
      state.problem = value;
    },
    CLAIM_LOAD(state, key) {
      if (!state.loadClaims.includes(key)) {
        state.loadClaims.push(key);
      }
    },
    RELEASE_LOAD(state, key) {
      const index = state.loadClaims.indexOf(key);
      if (index !== -1) {
        state.loadClaims.splice(index, 1);
      }
    },
  },
};
